// extracted by mini-css-extract-plugin
module.exports = {"spacingSmallResponsive":"uiComponentRef-module--spacingSmallResponsive--G5FpN","spacingMediumResponsive":"uiComponentRef-module--spacingMediumResponsive--3DJge"};